(ns renolit-roofing-service.view.service-add
  (:require [clojure.string :as string]
            [dev.gethop.session.re-frame.cognito.token :as session.token]
            [malli.core :as m]
            [malli.transform :as mt]
            [malli.util :as mu]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.components :refer [back-link]]
            [renolit-roofing-service.layout.info-bar :as layout.info-bar]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.shared.domain.service :as dom.service]
            [renolit-roofing-service.util :as util]
            [renolit-roofing-service.util.google-maps :as google-maps]
            [renolit-roofing-service.view :as view]
            [renolit-roofing-service.view.project-view :as view.project-details]
            [renolit-roofing-service.view.service.service-information :as view.service-information]
            [renolit-roofing-service.view.service.zone :as view.service.zone]
            [renolit-roofing-service.view.service.visit-program :as view.service.visit-program]))

(def zones
  [])

(def path-params-schema
  [:map
   [:project-id [:uuid]]])

(def ^:const route-config
  {:name [:service-add]
   :auth-req? true
   :parameters {:path path-params-schema}
   :controllers [{:parameters {:path (mu/keys path-params-schema)}
                  :start #(rf/dispatch [::view.on-enter %])
                  :stop #(rf/dispatch [::view.on-leave %])}]})

(rf/reg-event-fx
 ::view.on-enter
 (fn [_ [_ {{project-id :project-id} :path}]]
   {:fx [[:dispatch [::google-maps/initialize-zones zones]]
         [:dispatch [::load-project-address project-id]]]}))

(rf/reg-event-fx
 ::load-project-address
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [session]} [_ project-id]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :get
                 :uri (str "/api/projects/" project-id)
                 :params {:cols [:building-country :building-region :building-state :building-city :building-zip :building-street]}
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::project-address-success]
                 :on-failure [::util/generic-error]}}))

(rf/reg-event-fx
 ::project-address-success
 (fn [{:keys [db]} [_ {{:keys [building-country building-region building-state building-city building-zip building-street]} :project}]]
   (let [address (string/join ", " [building-street building-city building-zip building-state building-region building-country])]
     {:db (assoc db :project-address address)})))

(rf/reg-event-fx
 ::view.on-leave
 (fn [{:keys [_]} _]))

(rf/reg-event-fx
 ::create-service-success
 (fn [{:keys [_]} [_ service]]
   (rf/dispatch [::layout.info-bar/add-info-bar
                 {:context :add-service-view
                  :type :success
                  :disappear-in-ms 50000
                  :msg-transl-kw :page.service.add.success-msg}])
   (rf/dispatch [::nav/push-state (:name view.project-details/route-config) {:project-id (:project-id service)}])))

(rf/reg-event-fx
 ::create-service-failure
 (fn [{:keys [_]} [_ _e]]
   (rf/dispatch [::layout.info-bar/add-info-bar
                 {:context :add-service-view
                  :type :error
                  :disappear-in-ms 50000
                  :msg-transl-kw :page.service.add.failure-msg}])))

(rf/reg-event-fx
 ::create-service
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [session]} [_ service]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :post
                 :params service
                 :uri "/api/services"
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::create-service-success service]
                 :on-failure [::create-service-failure]}}))

(defn- parse-service-into-schema
  [raw-service raw-zones]
  (let [zones (->> raw-zones
                   (vals)
                   (filter #(some? (:zone/id %)))
                   (map (fn [{:zone/keys [id name polygon subzones]}]
                          {:id id
                           :name name
                           :area polygon
                           :subzones subzones})))
        reviews (->> raw-zones
                     (vals)
                     (filter #(some? (:poi/id %)))
                     (map (fn [{:poi/keys [id type parent-zone-id marker work-package]}]
                            {:id id
                             :type (case type
                                     :general-revision :general
                                     :focused-revision :focused)
                             :zone-id parent-zone-id
                             :lat-lng (when (= type :focused-revision) marker)
                             :wp (:wp work-package)
                             :wp-type (:wp-type work-package)
                             :tasks (:tasks work-package)})))
        service (m/decode dom.service/create-service-schema
                          (assoc raw-service :zones zones :reviews reviews)
                          mt/strip-extra-keys-transformer)]
    service))

(defn valid-service-details?
  [raw-service raw-zones]
  (let [service (parse-service-into-schema raw-service raw-zones)]
    (m/validate dom.service/create-service-schema service)))

(defn- submit-service
  [valid-input? raw-service raw-zones]
  (when valid-input?
    (let [service (parse-service-into-schema raw-service raw-zones)]
      (rf/dispatch [::create-service service]))))

(defn- main
  [project-id]
  (let [state (r/atom {:project-id project-id})
        tab (r/atom :service-information)
        zones (rf/subscribe [::google-maps/zones])]
    (fn []
      (let [valid-input? (valid-service-details? @state @zones)]
        [:div.user_layout
         [:div.user_layout_header
          [back-link (t [:common.go-back]) (nav/href [:project] {:project-id project-id})]
          [:span.button {:class (when-not valid-input? "disabled")
                         :on-click #(submit-service valid-input? @state @zones)}
           (t [:page.service.add.activate-diagnostic-service])]]
         [:div.project
          [:div.project_title-bar
           [:h1.user_layout_header_title (t [:page.service.add.title]) " " [:span.color-gray "(" (t [:common.project]) " " (str project-id) ")"]]]
          [:div.tabs
           [:div.tab
            {:class (when (#{:service-information} @tab) "active")
             :on-click #(reset! tab :service-information)}
            (t [:common.service-information])]
           [:div.tab
            {:class (when (#{:zones} @tab) "active")
             :on-click #(reset! tab :zones)}
            (t [:common.zones])]
           [:div.tab
            {:class (when (#{:visit-program} @tab) "active")
             :on-click #(reset! tab :visit-program)}
            (t [:common.visit-program])]]
          (case @tab
            :service-information
            [view.service-information/main state]

            :zones
            [view.service.zone/main]

            :visit-program
            [view.service.visit-program/main state])]]))))

(defmethod view/view-display (:name route-config)
  [{:keys [parameters]}]
  [main (get-in parameters [:path :project-id])])